import * as _ from 'lodash';
import { fromJS } from 'immutable';
import * as modelsActions from '../actions/models';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';

const initialStats = {
  allYears: {
    data: [],
    state: null,
  },
  adjustments: {
    data: [],
    state: null,
  },
  features: {
    data: [],
    state: null,
  },
  modelFeatures: {
    data: [],
    state: null,
  },
  adjustTypes: {
    data: [],
    state: null,
  },
  featureTypes: {
    data: [],
    state: null,
  },
  featureCodes: {
    data: [],
    state: null,
  },
  pricingComponents: {
    data: [],
    state: null,
  },
  areaTypes: {
    data: [],
    state: null,
  },
  codefile: {
    data: [],
    state: null,
  },
  schedules: {},
  pricingSchedules: {
    data: [],
    state: null,
  },
  revisionHistory: {
    data: [],
    state: null
  }
};
const getResults = action => fromJS(_.get(action, 'data.results', []));

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case modelsActions.FETCH_ALL_YEARS[START]: {
      return state.setIn(['allYears', 'state'], fetchingState.FETCHING);
    }
    case modelsActions.FETCH_ALL_YEARS[ERROR]: {
      return state.setIn(['allYears', 'state'], fetchingState.ERROR);
    }
    case modelsActions.FETCH_ALL_YEARS[SUCCESS]: {
      return state
        .setIn(['allYears', 'state'], fetchingState.LOADED)
        .setIn(
          ['allYears', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case modelsActions.FETCH_ADJUSTMENTS[START]: {
      return state.setIn(['adjustments', 'state'], fetchingState.FETCHING);
    }

    case modelsActions.FETCH_FEATURES[START]: {
      return state.setIn(['features', 'state'], fetchingState.FETCHING);
    }

    case modelsActions.FETCH_MODEL_FEATURES[START]: {
      return state.setIn(['modelFeatures', 'state'], fetchingState.FETCHING);
    }

    case modelsActions.FETCH_TYPES[START]: {
      return state.setIn(['adjustTypes', 'state'], fetchingState.FETCHING);
    }

    case modelsActions.FETCH_FEATURE_CODES[START]: {
      return state.setIn(['featureCodes', 'state'], fetchingState.FETCHING);
    }

    case modelsActions.FETCH_PRICING_COMPONENTS[START]: {
      return state.setIn(
        ['pricingComponents', 'state'],
        fetchingState.FETCHING,
      );
    }

    case modelsActions.FETCH_PRICING_SCHEDULES[START]: {
      return state.setIn(['pricingSchedules', 'state'], fetchingState.FETCHING);
    }

    case modelsActions.FETCH_SCHEDULES[START]: {
      return state.setIn(
        ['schedules', action.modelComponentID, 'state'],
        fetchingState.FETCHING,
      );
    }

    case modelsActions.FETCH_ADJUSTMENTS[SUCCESS]: {
      return state
        .setIn(['adjustments', 'state'], fetchingState.LOADED)
        .setIn(['adjustments', 'data'], getResults(action));
    }

    case modelsActions.FETCH_FEATURES[SUCCESS]: {
      return state
        .setIn(['features', 'state'], fetchingState.LOADED)
        .setIn(['features', 'data'], getResults(action));
    }

    case modelsActions.FETCH_MODEL_FEATURES[SUCCESS]: {
      return state
        .setIn(['modelFeatures', 'state'], fetchingState.LOADED)
        .setIn(['modelFeatures', 'data'], getResults(action));
    }

    case modelsActions.FETCH_FEATURE_CODES[SUCCESS]: {
      return state
        .setIn(['featureCodes', 'state'], fetchingState.LOADED)
        .setIn(['featureCodes', 'data'], getResults(action));
    }

    case modelsActions.FETCH_PRICING_COMPONENTS[SUCCESS]: {
      return state
        .setIn(['pricingComponents', 'state'], fetchingState.LOADED)
        .setIn(['pricingComponents', 'data'], getResults(action));
    }

    case modelsActions.FETCH_AREA_TYPES[SUCCESS]: {
      return state
        .setIn(['areaTypes', 'state'], fetchingState.LOADED)
        .setIn(['areaTypes', 'data'], getResults(action));
    }

    case modelsActions.FETCH_CODEFILE[SUCCESS]: {
      return state
        .setIn(['codefile', 'state'], fetchingState.LOADED)
        .setIn(['codefile', 'data'], getResults(action));
    }

    case modelsActions.SET_SCHEDULES_ORDER[SUCCESS]:
    case modelsActions.FETCH_SCHEDULES[SUCCESS]: {
      return state
        .setIn(
          ['schedules', action.modelComponentID, 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['schedules', action.modelComponentID, 'data'],
          getResults(action),
        );
    }

    case modelsActions.FETCH_PRICING_SCHEDULES[SUCCESS]: {
      return state
        .setIn(['pricingSchedules', 'state'], fetchingState.LOADED)
        .setIn(['pricingSchedules', 'data'], getResults(action));
    }

    case modelsActions.DELETE_ADJUSTMENTS[SUCCESS]: {
      const { modelAdjustID } = action;
      return state.updateIn(['adjustments', 'data'], data =>
        data.filter(
          adj =>
            adj.get('modelAdjustID').toString() !== modelAdjustID.toString(),
        ),
      );
    }

    case modelsActions.DELETE_PRICING_COMPONENTS[SUCCESS]: {
      const { modelComponentID } = action;
      return state.updateIn(['pricingComponents', 'data'], data =>
        data.filter(
          obj =>
            obj.get('modelComponentID').toString() !==
            modelComponentID.toString(),
        ),
      );
    }

    case modelsActions.DELETE_FEATURE_CODE[SUCCESS]: {
      const { featureCodeID } = action;
      return state.updateIn(['featureCodes', 'data'], data =>
        data.filter(
          adj =>
            adj.get('featureCodeID').toString() !== featureCodeID.toString(),
        ),
      );
    }

    case modelsActions.DELETE_FEATURE[SUCCESS]: {
      const { featureID } = action;
      return state.updateIn(['features', 'data'], data =>
        data.filter(
          adj => adj.get('featureID').toString() !== featureID.toString(),
        ),
      );
    }

    case modelsActions.DELETE_MODEL_FEATURE[SUCCESS]: {
      const { modelFeatureID } = action;
      return state.updateIn(['modelFeatures', 'data'], data =>
        data.filter(
          adj =>
            adj.get('modelFeatureID').toString() !== modelFeatureID.toString(),
        ),
      );
    }

    case modelsActions.DELETE_SCHEDULES_PRICING[SUCCESS]: {
      const { modelComponentDetailPricingID, modelComponentID } = action;
      return state.updateIn(['schedules', modelComponentID, 'data'], data =>
        data.filter(
          adj =>
            adj.get('modelComponentDetailPricingID').toString() !==
            modelComponentDetailPricingID.toString(),
        ),
      );
    }

    case modelsActions.DELETE_DETAILED_FIXED_INCREMENT_ADJUSTMENTS[SUCCESS]: {
      const { modelComponentFixedIncrementAdjustmentID, modelComponentID } = action;
      return state.updateIn(['schedules', modelComponentID, 'data'], data =>
        data.filter(
          adj =>
            adj.get('modelComponentFixedIncrementAdjustmentID').toString() !==
            modelComponentFixedIncrementAdjustmentID.toString(),
        ),
      );
    }

    case modelsActions.DELETE_SCHEDULES_UNIT[SUCCESS]: {
      const { modelComponentUnitCostAdjustmentID, modelComponentID } = action;
      return state.updateIn(['schedules', modelComponentID, 'data'], data =>
        data.filter(
          adj =>
            adj.get('modelComponentUnitCostAdjustmentID').toString() !==
            modelComponentUnitCostAdjustmentID.toString(),
        ),
      );
    }

    case modelsActions.DELETE_SCHEDULES_INCREMENT[SUCCESS]: {
      const {
        modelComponentFixedIncrementAdjustmentID,
        modelComponentID,
      } = action;
      return state.updateIn(['schedules', modelComponentID, 'data'], data =>
        data.filter(
          adj =>
            adj.get('modelComponentFixedIncrementAdjustmentID').toString() !==
            modelComponentFixedIncrementAdjustmentID.toString(),
        ),
      );
    }

    case modelsActions.DELETE_SCHEDULES_DEPRECIATION[SUCCESS]: {
      const { modelComponentDetailPricingID, modelComponentID } = action;
      return state.updateIn(['schedules', modelComponentID, 'data'], data =>
        data.filter(
          adj =>
            adj.get('modelComponentDetailPricingID').toString() !==
            modelComponentDetailPricingID.toString(),
        ),
      );
    }

    case modelsActions.FETCH_TYPES[SUCCESS]: {
      return state
        .setIn(
          ['adjustTypes', 'data'],
          getResults(action).get('adjustTypes', []),
        )
        .setIn(['adjustTypes', 'state'], fetchingState.LOADED);
    }

    case modelsActions.FETCH_FEATURE_TYPES[SUCCESS]: {
      return state
        .setIn(
          ['featureTypes', 'data'],
          getResults(action).get('featureValueTypes', []),
        )
        .setIn(['featureTypes', 'state'], fetchingState.LOADED);
    }

    case modelsActions.INSERT_ADJUSTMENT[SUCCESS]: {
      return state.updateIn(['adjustments', 'data'], data =>
        data.push(fromJS(_.get(action, 'data.results[0]', {}))),
      );
    }

    case modelsActions.INSERT_PRICING_COMPONENTS[SUCCESS]: {
      return state.updateIn(['pricingComponents', 'data'], data =>
        data.push(fromJS(_.get(action, 'data.results[0]', {}))),
      );
    }

    case modelsActions.INSERT_FEATURE[SUCCESS]: {
      return state.updateIn(['features', 'data'], data =>
        data.push(fromJS(_.get(action, 'data.results[0]', {}))),
      );
    }

    case modelsActions.INSERT_MODEL_FEATURE[SUCCESS]: {
      return state.updateIn(['modelFeatures', 'data'], data =>
        data.push(fromJS(_.get(action, 'data.results[0]', {}))),
      );
    }

    case modelsActions.INSERT_FEATURE_CODE[SUCCESS]: {
      return state.updateIn(['featureCodes', 'data'], data =>
        data.push(fromJS(_.get(action, 'data.results[0]', {}))),
      );
    }

    case modelsActions.INSERT_SCHEDULES[SUCCESS]: {
      return state.updateIn(
        ['schedules', action.modelComponentID, 'data'],
        data => data.push(fromJS(_.get(action, 'data.results[0]', {}))),
      );
    }

    case modelsActions.UPDATE_ADJUSTMENT[SUCCESS]: {
      return state.updateIn(['adjustments', 'data'], data => {
        const { modelAdjustID } = _.get(action, 'data.results[0]', {});
        const index = data.findIndex(
          adj =>
            modelAdjustID.toString() === adj.get('modelAdjustID').toString(),
        );

        return data.set(index, fromJS(_.get(action, 'data.results[0]', {})));
      });
    }
    case modelsActions.UPDATE_COMPONENT_TYPES[SUCCESS]:
    case modelsActions.UPDATE_PRICING_COMPONENTS[SUCCESS]: {
      const { modelComponentID } = action;
      return state.updateIn(['pricingComponents', 'data'], data => {
        const index = data.findIndex(
          adj =>
            modelComponentID.toString() ===
            adj.get('modelComponentID').toString(),
        );

        return data.set(index, fromJS(_.get(action, 'data.results[0]', {})));
      });
    }

    case modelsActions.UPDATE_FEATURE_CODE[SUCCESS]: {
      return state.updateIn(['featureCodes', 'data'], data => {
        const { featureCodeID } = _.get(action, 'data.results[0]', {});
        const index = data.findIndex(
          adj =>
            featureCodeID.toString() === adj.get('featureCodeID').toString(),
        );

        return data.set(index, fromJS(_.get(action, 'data.results[0]', {})));
      });
    }

    case modelsActions.FETCH_REVISION_HISTORY[START]: {
      return state.setIn(['revisionHistory', 'state'], fetchingState.FETCHING);
    }
    case modelsActions.FETCH_REVISION_HISTORY[ERROR]: {
      return state.setIn(['revisionHistory', 'state'], fetchingState.ERROR)
        .setIn(
          ['revisionHistory', 'data'],
          fromJS([]),
        )
    }
    case modelsActions.FETCH_REVISION_HISTORY[SUCCESS]: {
      return state
        .setIn(['revisionHistory', 'state'], fetchingState.LOADED)
        .setIn(
          ['revisionHistory', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    default:
      return state;
  }
};
